import {FormattedMessage} from "react-intl";
import React from "react";
import InitialQuotationState from "../../InitialQuotationState";
import {Link} from "react-router-dom";


const Dimensions = (props) => {
let selectedfrmwrk = props.stnclParams;
    let Data  = [];
    let selectedLang = InitialQuotationState.lang;

    if(selectedfrmwrk===0){

           if(selectedLang ==='en'){

               Data =[
                   {id : 112 , value : "380×280（Valid area 290×190mm)"},
                   {id : 501 , value : "420×320（Valid area 400×240mm）"},
                   {id : 502 , value : "450×350（Valid area 420×270mm）"},
                   {id : 503 , value : "520×420（Valid area 490×340mm）"},
                   {id : 504 , value : "460×460（Valid area 430×380mm）"},
               ];
        } else if(selectedLang === 'ja'){

               Data =[
                   {id : 112 , value : "380×280（有効エリア290×190mm)"},
                   {id : 501 , value : "420×320（有効エリア400×240mm)"},
                   {id : 502 , value : "450×350（有効エリア420×270mm)"},
                   {id : 503 , value : "520×420（有効エリア490×340mm)"},
                   {id : 504 , value : "460×460（有効エリア430×380mm)"},
               ];
        }


    }else {
        if(selectedLang ==='en'){
            Data =[
                {id : 2 , value : "470×370（Valid area 290×190mm）"},
                {id : 111 , value : "400×300（Valid area 240×140mm）"},
                {id : 3 , value : "520×420（Valid area 340×240mm）"},
                {id : 6 , value : "550×450（Valid area 370×270mm）"},
                {id : 7 , value : "584×584（Valid area 380×380mm）"},
                {id : 5 , value : "650×550（Valid area 450×350mm）"},
                {id : 124 , value : "700×500（Valid area 500×320mm）"},
                {id : 108 , value : "600×400（Valid area 400×220mm）"},
                {id : 8 , value : "736×736（Valid area 500×500mm）"},
                {id : 109 , value : "800×400（Valid area 600×220mm）"},
                {id : 114 , value : "800×500（Valid area 600×320mm）"},
                {id : 110 , value : "1000×400（Valid area 760×220mm）"},
            ];
        }else if(selectedLang === 'ja'){

            Data =[

                {id : 2 , value : "470×370（有効エリア290×190mm）"},
                {id : 111 , value : "400×300（有効エリア240×140mm）"},
                {id : 3 , value : "520×420（有効エリア340×240mm）"},
                {id : 6 , value : "550×450（有効エリア370×270mm）"},
                {id : 7 , value : "584×584（有効エリア380×380mm）"},
                {id : 5 , value : "650×550（有効エリア450×350mm）"},
                {id : 124 , value : "700×500（有効エリア500×320mm）"},
                {id : 108 , value : "600×400（有効エリア400×220mm）"},
                {id : 8 , value : "736×736（有効エリア500×500mm）"},
                {id : 109 , value : "800×400（有効エリア600×220mm）"},
                {id : 114 , value : "800×500（有効エリア600×320mm）"},
                {id : 110 , value : "1000×400（有効エリア760×220mm）"},
            ];
        }

    }
    let MakeItem = function(X) {
        return <option value={X.id}>{X.value}</option>;
    };
    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="stencil-details-div">
                    <div className="col-md-3 text-right stencil-content-item-heading">
                        <FormattedMessage id="app.stencil-quotation.stencil-dimensions"
                                          defaultMessage="Dimensions"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        {/*<Link id="pcbstnclDim-qLink" to="/help/stncl_dim"*/}
                              {/*className="glyphicon glyphicon-question-sign question-link"></Link>*/}
                    </div>

                    <div className="col-md-5 stencil-details-div-items selectDimension stencil-details-div-items1">
                        <select  name="dimension" onChange={props.setDimensions} className="form-control dimensions-select"
                                value={props.selectedId} >{Data.map(MakeItem)}</select>

                    </div>

                    <div className="col-md-3">

                    </div>
                </div>
            </div>
        </div>
    )
};

export default Dimensions;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/StencilQuotationForm/StencilQuotationFormFields/Dimensions.js